import { Link } from 'react-router'

import type { ArtistSummary } from '@/api/types'
import { Cover } from '@/components/Cover'
import { Skeleton } from '@/components/ui'
import { artistSummaryHref } from '@/features/artists/artistHref'

export function ArtistGrid({ artists }: { artists: ArtistSummary[] }) {
  return (
    <ul className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">
      {artists.map((artist) => (
        <li key={`${artist.provider}:${artist.external_id}`}>
          <Link
            to={artistSummaryHref(artist)}
            className="flex flex-col items-center gap-2 rounded-card p-3 text-center transition-colors hover:bg-surface-hover"
          >
            <Cover src={artist.picture_url} size="xl" className="rounded-full" />
            <span className="w-full truncate text-sm font-medium text-text">{artist.name}</span>
            <span className="text-xs text-text-muted">
              {artist.popularity == null ? 'Artist' : `${artist.popularity.toLocaleString()} ${artist.popularity === 1 ? 'fan' : 'fans'}`}
            </span>
          </Link>
        </li>
      ))}
    </ul>
  )
}

export function ArtistGridSkeleton() {
  return (
    <div role="status" aria-label="Loading artists" className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">
      {Array.from({ length: 8 }, (_, index) => (
        <div key={index} className="flex flex-col items-center gap-2 p-3">
          <Skeleton className="aspect-square w-full rounded-full" />
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="h-3 w-1/3" />
        </div>
      ))}
    </div>
  )
}
